import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    boxContainer: {
        width: "100%",
    },
    boxContainerSeparator: {
        width: "100%",
        paddingBottom: "30px",
        borderBottom: `1px solid ${theme.palette.corporateBO.lineSeparator}`,
    },
    formContainer: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        padding: "8px 30px 0",
    },
    formLabel: {
        "&.MuiTypography-root": {
            fontFamily: "Source Sans 3",
            fontWeight: 700,
            fontSize: "12px",
            textTransform: "uppercase",
            color: theme.palette.primary.dark,
        },
        "&.MuiFormLabel-root": {
            fontFamily: "Source Sans 3",
            fontWeight: 700,
            fontSize: "12px",
            textTransform: "uppercase",
            color: theme.palette.primary.dark,
        },
        "&.MuiFormLabel-root.Mui-focused": {
            color: theme.palette.primary.dark,
        },
    },
    checkbox: {
        "&.MuiCheckbox-root": {
            color: theme.palette.corporateBO.checkbox,
            "&.Mui-checked": {
                color: theme.palette.info.main,
            },
        },
    },
    textField: {
        width: "100%",
        height: 56,
        "& .MuiOutlinedInput-root": {
            fontFamily: "Source Sans 3",
            fontSize: "16px",
            fontWeight: "400",
            "&.MuiOutlinedInput-input": {
                fontFamily: "Source Sans 3",
                fontSize: "16px",
                fontWeight: "400",
            },
            "&.Mui-focused fieldset": {
                borderColor: theme.palette.info.main,
            },
        },
        "& .MuiInputLabel-outlined": {
            fontFamily: "Source Sans 3",
            fontSize: "16px",
            fontWeight: "400",
            "&.Mui-focused": {
                color: theme.palette.info.light,
            },
        },
    },
    tooltip: {
        "&.MuiTooltip-popper .MuiTooltip-tooltip": {
            background: theme.palette.secondary.main,
        },
    },
    tooltipTexts: {
        "&.MuiTypography-root": {
            fontSize: "14px",
            borderBottom: "1px solid rgba(193, 200, 218, 1)",
            textAlign: "left",
            color: theme.palette.text.primary,
            fontWeight: 600,
            fontFamily: "Source Sans 3",
            paddingBottom: "5px",
        },
    },
    buttonsContainer: {
        width: "100%",
        marginTop: theme.spacing(6),
        borderTop: `1px solid ${theme.palette.corporateBO.lineSeparator}`,
        padding: "15px 30px",
        display: "flex",
        justifyContent: "flex-end",
    },
    addButton: {
        "&.MuiButton-root": {
            background: theme.palette.info.main,
            fontFamily: "Source Sans 3",
            fontWeight: 700,
            fontSize: "12px",
            color: theme.palette.primary.main,
            marginLeft: "15px",
        },
        "&.MuiButton-root:hover": {
            background: theme.palette.info.main,
        },
    },
    cancelButton: {
        "&.MuiButtonBase-root": {
            fontFamily: "Source Sans 3",
            fontWeight: 700,
            fontSize: "12px",
            color: theme.palette.primary.dark,
        },
    },
    select: {
        textAlign: "left",
    },
    switch: {
        "&.MuiSwitch-root .MuiButtonBase-root .MuiSwitch-thumb": {
            background: theme.palette.primary.dark,
        },
        "&.MuiSwitch-root .Mui-checked .MuiSwitch-thumb": {
            background: theme.palette.info.main,
        },
        "&.MuiSwitch-root .MuiSwitch-track": {
            background: theme.palette.corporateBO.checkboxTrack,
        },
        "&.MuiSwitch-root .Mui-checked+ .MuiSwitch-track": {
            background: theme.palette.corporateBO.checkboxTrackChecked,
        },
    },
    tabsHeader: {
        width: "100%",
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(2),
        marginBottom: theme.spacing(1),
    },
    tabs: {
        padding: "0 0 16px 0",
        "&.MuiTabs-root .MuiTabs-scroller .MuiTabs-indicator": {
            borderBottom: "none",
            backgroundColor: "transparent",
        },
        "&.MuiTabs-root .MuiTabs-scroller .MuiTabs-flexContainer .MuiButtonBase-root": {
            fontFamily: "Source Sans 3",
            fontWeight: 400,
            fontSize: "14px",
            color: theme.palette.corporateBO.tabText,
            textTransform: "none",
            padding: 0,
            minWidth: 0,
        },
        "&.MuiTabs-root .MuiTabs-scroller .MuiTabs-flexContainer .Mui-selected": {
            fontFamily: "Source Sans 3",
            fontWeight: 600,
            fontSize: "14px",
            color: theme.palette.corporateBO.tabText,
            textTransform: "none",
            borderBottom: `3px solid ${theme.palette.border.tabs}`,
        },
        "&.MuiTabs-root .MuiTabs-scroller .MuiTabs-flexContainer": {
            gap: theme.spacing(6),
        },
    },
    tabPanel: {
        width: "100%",
        paddingTop: 0,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: theme.spacing(6),
    },
    tabErrorIcon: {
        "&.MuiSvgIcon-root": {
            fontSize: "14px",
            color: theme.palette.error.main,
            verticalAlign: "middle",
            marginLeft: "4px",
        },
    },
    productInputRow: {
        display: "flex",
        gap: theme.spacing(2),
        width: "100%",
        alignItems: "flex-start",
    },
    productOutputContainer: {
        width: "100%",
        marginTop: theme.spacing(4),
    },
    productList: {
        "&.MuiList-root": {
            paddingTop: 0,
        },
        width: "100%",
        marginTop: theme.spacing(2),
    },
    productListItem: {
        display: "flex",
        boxShadow: "inset 0px -1px 0px rgba(0, 0, 0, 0.12)",
        padding: `${theme.spacing(1)} 0`,
    },
    productListText: {
        "&.MuiListItemText-root .MuiTypography-root": {
            fontFamily: "Source Sans 3",
            fontSize: "14px",
            color: theme.palette.secondary.dark,
        },
        flex: 1,
    },
    productEditRow: {
        display: "flex",
        gap: theme.spacing(2),
        width: "100%",
        alignItems: "flex-start",
    },
    switchLabel: {
        "&.MuiFormControlLabel-root": {
            width: "100%",
            justifyContent: "flex-end",
            margin: 0,
        },
        "&.MuiFormControlLabel-root .MuiTypography-root": {
            fontFamily: "Source Sans 3",
            fontWeight: 400,
            fontSize: "14px",
            color: theme.palette.text.secondary,
        },
    },
}));
